<!-- 
Panel for displaying the invoice timing configuration for a levy collection.
-->
<template>
  <div class="my-0">
    <our-data-container>
      <our-data-field label="Days invoice is due after raising" label-width="3">
        {{ configuration.daysInvoiceIsDueAfterGeneratingInvoice | number }}
      </our-data-field>
      <our-data-field label="Days before invoice is due to send payment due reminder notice" label-width="3">
        {{ configuration.daysBeforeInvoiceIsDueToSendPaymentDueReminderNotice | number }}
      </our-data-field>
      <our-data-field label="Days after invoice is due to send payment overdue warning notice" label-width="3">
        {{ configuration.daysAfterInvoiceIsDueToSendPaymentOverdueWarningNotice | number }}
      </our-data-field>
      <our-data-field label="Days after invoice is due to display warnings" label-width="3">
        {{ configuration.daysAfterInvoiceIsDueToDisplayWarning | number }}
      </our-data-field>
    </our-data-container>
    <div class="text-xs-center py-2">
      <v-btn v-if="canEdit" @click="showEditDialog=true">
        <v-icon class="mr-2">edit</v-icon>
        Edit
      </v-btn>
    </div>
    <invoice-timing-configuration-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" />
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as claim from "@/store/claim-types";
import * as action from "@/store/levy-collections/action-types";
import InvoiceTimingConfigurationDialog from "@/components/levy-collection-setup/InvoiceTimingConfigurationDialog.vue";

export default {
  components: { InvoiceTimingConfigurationDialog },
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showEditDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.viewInvoicingTimingConfiguration;
    },
    loaded() {
      return this.state.loaded;
    },
    configuration() {
      return this.state.data;
    },
    canEdit() {
      const hasPermission = this.$store.getters.claims.includes(claim.LEVY_COLLECTION_CONFIGURE_INVOICING_TIMING);
      const isAllowableStatus = this.doesLookupHaveAttribute(
        this.configuration.status,
        "CanEditInvoiceTimingConfiguration",
        this.lookups.levyCollectionStatuses
      );
      return hasPermission && isAllowableStatus;
    },
    showLevyParametersAsAtDate() {
      return this.state.data.levyCollectionType == "Vsl";
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      const needsReloaded =
        (!this.state.loaded && !this.state.loading) || this.state.levyCollectionId != this.levyCollectionId;
      if (needsReloaded) {
        this.$store.dispatch(action.VIEW_INVOICING_TIMING_CONFIGURATION, this.levyCollectionId);
      }
    }
  }
};
</script>
